import $ from 'jquery'
import throttle from 'lodash/throttle'

const edgeThreshold = 5

export function initialise() {
  $('[data-overflow-shadow]').each((i, elem) => {
    const $elem = $(elem)
    const $inner = $elem.find('[data-overflow-shadow-inner]')

    $elem.find('.overflow-shadow').remove()
    const shadowElems = {}
    'trbl'.split('').forEach(l => {
      const $shad = $(`<div class="overflow-shadow overflow-shadow-${l}" style="opacity:0" />`)
      $shad.appendTo($elem)
      shadowElems[l] = $shad
    })

    $inner.on('scroll', e => handleScroll($inner, shadowElems))
    $(window).on('resize', e => handleScroll($inner, shadowElems))
    handleScroll($inner, shadowElems)
    setTimeout(() => Object.values(shadowElems).map($elem => $elem.css('opacity', '')), 250)
  })
}

const _handleScroll = ($elem, shadowElems) => {
  const scrollTop = $elem.scrollTop()
  const scrollLeft = $elem.scrollLeft()
  const scrollWidth = $elem[0].scrollWidth
  const scrollHeight = $elem[0].scrollHeight
  const viewportWidth = $elem.outerWidth()
  const viewportHeight = $elem.outerHeight()

  if (scrollLeft < edgeThreshold) shadowElems.l.addClass('hide')
  else shadowElems.l.removeClass('hide')

  if (scrollLeft + viewportWidth > scrollWidth - edgeThreshold) shadowElems.r.addClass('hide')
  else shadowElems.r.removeClass('hide')

  if (scrollTop < edgeThreshold) shadowElems.t.addClass('hide')
  else shadowElems.t.removeClass('hide')

  if (scrollTop + viewportHeight > scrollHeight - edgeThreshold) shadowElems.b.addClass('hide')
  else shadowElems.b.removeClass('hide')
}

const handleScroll = throttle(_handleScroll, 1000 / 60)

window.initOverflowShadow = () => initialise()
